import React, { useState } from "react";
import BackendLayout from "../../layouts/BackendLayout";
import {
  ButtonFilterSearch,
  CheckboxInput,
  PageAlert, RedirectAlert,
  TextInput,
  TextLink,
} from "../../components";
import Table from "../../components/table/Table";
import Pagination from "../../components/Pagination";
import {
  ButtonTableEdit,
  ButtonTableDelete,
  ButtonAdd,
  ButtonDPad,
} from "../../components/buttons";
import {
  useWorkFollowList,
  useWorkFollowListPageSetting,
} from "../../hooks/MachineWorkFlowHook";
import Select2 from "../../components/Select2";
import _ from "lodash";
import { toDatetimeStr } from "../../utils/datetime-utils";
import { getSelectedValue } from "../../utils/select-utils";
import { pushToFirst } from "../../utils/array-utils";
import { deleteWorkFollows } from "../../services/MachineWorkFlowServices";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";
import * as routes from "../../constants/routes";
import ExpandableDiv from "../../components/table/ExpandableDiv";
import { useDocumentTitle } from "../../hooks";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import {
  ButtonTableBulkDelete,
  PageTitle,
  SelectInput,
} from "../../components";
import {
  clearButtonProcessing,
  setAlertSuccess,
  setButtonProcessing,
} from "../../store/actions";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import { updateUserSetting } from "../../services/user-master/UserSettingServices";
import { USER_SETTING_CATEGORIES } from "../../constants/app";
import { errorStatusHandle } from "../../utils";
import {APPROVAL_SETTING_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function ApprovalSettingsList() {
  useRedirectPage(APPROVAL_SETTING_PAGE);
  useDocumentTitle("承認設定マスタ更新 - 点検王");
  const dispatch = useDispatch();
  const breadcrumb = getRouteBreadcrumb(routes.APPROVAL_SETTING);
  const [reload, setReload] = useState(0);
  const {
    tableData,
    page,
    count,
    setTableData,
    setPage,
    setFilters,
    perPage,
    setPerPage,
  } = useWorkFollowList(reload);
  const { templates, frequencies, filterList, setFilterList } =
    useWorkFollowListPageSetting(setFilters);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteIds, setDeleteIds] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [confirmDeleteMessage, setConfirmDeleteMessage] = useState("");

  const handleChangeFilter = (e) => {
    setFilterList({ ...filterList, [e.target.name]: e.target.value });
  };
  const handleSearch = () => {
    updateSettings();
    setFilters(filterList);
  };
  const handleCheckDelete = (e, index) => {
    const data = [...tableData];
    if (index !== undefined) {
      data[index].delete = !!e.target.checked;
    }
    setTableData(data);
  };

  const updateSettings = async () => {
    try {
      const { workflow_name, ...newFormatFilterList } = filterList;
      const response = await updateUserSetting(
        newFormatFilterList,
        USER_SETTING_CATEGORIES.APPROVAL_SETTINGS
      );
    } catch (e) {
      errorStatusHandle(e);
    }
  };

  const handleSubmitDelete = (e) => {
    let ids = [...deleteIds];
    if (ids.length === 0) {
      let deleteRows = _.filter(tableData, (row) => row.delete === true);
      ids = deleteRows.map((row) => {
        return row.id;
      });
    }
    dispatch(setButtonProcessing("delete-workflow"));
    deleteWorkFollows(ids)
      .then((response) => {
        setDeleteIds([]);
        setDeleteModal(false);
        setReload(reload + 1);
        dispatch(setAlertSuccess(response.message));
      })
      .catch((e) => {
        //
      })
      .finally(() => {
        dispatch(clearButtonProcessing("delete-workflow"));
      });
  };

  const handleShowDeleteModal = (row, index) => {
    if (row) {
      let confirmMessage = `承認設定名：${row.name}を削除します。\nこの操作は元には戻せません。\n\n削除してもよろしいでしょうか？`;
      setConfirmDeleteMessage(confirmMessage);
      setDeleteIds([row.id]);
      setDeleteModal(true);
    } else {
      let deleteRows = _.filter(tableData, (row) => row.delete === true);
      let confirmMessage = [
        `選択された以下の職位を削除します。\nこの操作は元には戻せません。\n`,
      ];
      if (deleteRows.length > 0) {
        let messageNames = deleteRows.map((r) => {
          return `\n承認設定名：${r.name}`;
        });
        confirmMessage = [
          ...confirmMessage,
          ...messageNames,
          "\n\n削除してもよろしいでしょうか？",
        ];
        setConfirmDeleteMessage(confirmMessage.join(""));

        setDeleteModal(true);
      }
    }
  };

  const handleChangeTemplate = (e) => {
    const newFilter = { ...filterList };
    let valueTemplate = e;
    if (e) {
      newFilter["template"] = e.value;
      valueTemplate = e.value;
    } else {
      newFilter["template"] = e;
    }
    setFilterList(newFilter);
  };

  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title={breadcrumb[breadcrumb.length - 1]?.menu} />
      <RedirectAlert />
      <PageAlert />
      <ButtonDPad />
      <div className="w-fit xl:w-full pr-6 xl:pr-0">
        <div className="w-full bg-white flex px-[24px] pt-[20px] pb-[20px] border border-tenken-gray-300 rounded-lg min-w-[800px] space-x-5 lg:space-x-6">
          <div className="xl:h-[76px] w-wit flex flex-col">
            <label>
              <b>承認設定名</b>
            </label>
            <TextInput
              type="text"
              value={filterList.workflow_name ?? ""}
              className="mt-[12px] lg:w-[240px] w-[200px]"
              placeholder="承認設定名"
              name="workflow_name"
              maxLength={40}
              onChange={handleChangeFilter}
              autoFocus
            />
          </div>
          <div className="xl:h-[76px] flex flex-col">
            <label>
              <b>承認頻度</b>
            </label>
            <SelectInput
              className="mt-[12px] lg:w-[140px] w-[120px]"
              value={filterList.frequency}
              options={frequencies}
              placeholder="承認頻度"
              name="frequency"
              nextFocus="template_id"
              onChange={handleChangeFilter}
            />
          </div>
          <div className="xl:h-[76px] flex flex-col">
            <label>
              <b>点検テンプレート</b>
            </label>
            <Select2
              className="mt-[12px] lg:w-[240px] w-[200px]"
              isClearable={false}
              classNamePrefix="react-select"
              value={getSelectedValue(templates, filterList.template)}
              options={templates}
              name="template"
              placeholder="点検テンプレート"
              onChange={handleChangeTemplate}
              maxLength={40}
            />
          </div>
          <div className="xl:w-[284px] xl:h-[76px] lg:pt-9 pt-[34px]">
            <ButtonFilterSearch onClick={handleSearch} />
          </div>
        </div>

        <div className="mt-[24px] relative rounded-lg border border-tenken-gray-300 border-collapse min-w-[1000px]">
          <Table striped>
            <Table.Head>
              <Table.HeadCell className="whitespace-nowrap">
                承認設定名
              </Table.HeadCell>
              <Table.HeadCell className="whitespace-nowrap">
                承認頻度
              </Table.HeadCell>
              <Table.HeadCell className="whitespace-nowrap">
                点検テンプレート
              </Table.HeadCell>
              <Table.HeadCell className="whitespace-nowrap">
                作成日時
              </Table.HeadCell>
              <Table.HeadCell className="whitespace-nowrap">
                更新日時
              </Table.HeadCell>
              <Table.HeadCell className="w-[120px]"></Table.HeadCell>
              <Table.HeadCell className="w-[92px]">
                <ButtonTableBulkDelete
                  type="button"
                  onClick={() => handleShowDeleteModal()}
                />
              </Table.HeadCell>
            </Table.Head>
            <Table.Body className="devide-y text-base relative">
              <LoadingSpinner component="workflow_list" />
              {tableData.map((row, idx) => (
                <Table.Row
                  key={idx}
                  className={row.delete ? "!bg-[#FFE7E7]" : ""}
                >
                  <Table.Cell className="max-w-[240px] 2xl:max-w-[440px] truncate">
                    <TextLink
                      href={`${routes.APPROVAL_SETTING}/${row.id}`}
                      className="text-tenken-link"
                    >
                      <span title={row.name}>{row.name}</span>
                    </TextLink>
                  </Table.Cell>
                  <Table.Cell className="whitespace-nowrap">
                    {_.find(frequencies, ["value", row.frequency])?.label}
                  </Table.Cell>
                  <Table.Cell>
                    {row.templates.length < 2 ? (
                      <div className="max-w-[280px] 2xl:max-w-[460px] truncate">
                        {pushToFirst(
                          filterList.template,
                          row.templates,
                          "id"
                        ).map((t) => {
                          return <span title={t.name} key={t.id}>{t.name}</span>;
                        })}
                      </div>
                    ) : (
                      <ExpandableDiv
                        expandable={true}
                        expanded={expanded}
                        setExpanded={setExpanded}
                        id={row.id}
                        className="w-full -ml-4"
                      >
                        {pushToFirst(
                          filterList.template,
                          row.templates,
                          "id"
                        ).map((t) => {
                          return <div key={t.id}>{t.name}</div>;
                        })}
                      </ExpandableDiv>
                    )}
                  </Table.Cell>
                  <Table.Cell className="whitespace-nowrap">
                    {toDatetimeStr(row.created_at)}
                  </Table.Cell>
                  <Table.Cell className="whitespace-nowrap">
                    {toDatetimeStr(row.updated_at)}
                  </Table.Cell>
                  <Table.Cell>
                    <div className="flex justify-center align-center">
                      <ButtonTableEdit
                        className="mr-[8px]"
                        as="a"
                        href={`${routes.APPROVAL_SETTING}/${row.id}`}
                      />
                      <ButtonTableDelete
                        type="button"
                        onClick={() => handleShowDeleteModal(row)}
                      />
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <CheckboxInput
                      position="justify-center"
                      name="delete"
                      checked={row.delete}
                      onChange={(e) => handleCheckDelete(e, idx)}
                      value={row.group_id}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        <div className="w-full md:mt-3 xl:mt-6">
          <div className="xl:flex xl:items-center xl:space-x-2">
            <ButtonAdd
              className="w-[150px]"
              as="a"
              href={`${routes.APPROVAL_SETTING}/new`}
            >
              承認設定作成
            </ButtonAdd>
            <div className="xl:mt-0 mt-3 w-full">
              <Pagination
                setPage={setPage}
                currentPage={page}
                pageSize={perPage}
                setPageSize={setPerPage}
                totalCount={count}
              />
            </div>
          </div>
        </div>
      </div>
      <ConfirmDeleteModal
        onConfirm={handleSubmitDelete}
        message={confirmDeleteMessage}
        showModal={deleteModal}
        setShowModal={setDeleteModal}
        onCancel={() => setDeleteModal(false)}
        buttonConfirmId="delete-workflow"
      ></ConfirmDeleteModal>
    </BackendLayout>
  );
}
